const styles = theme => ({
  backButton: {
    position: 'absolute',
    top: '24px',
    left: '32px',
    display: 'flex',
    '&:hover': { cursor: 'pointer' },
  },
})
export default styles
